import { useEffect, useState } from 'react';
import { isEmpty } from 'lodash-es';
import { motion, AnimatePresence } from 'framer-motion';
import { X } from 'lucide-react';

import { getNotifications } from '@/api/api';
import { Notification } from '@/api/models';

const MessagePopup = () => {
  const [notification, setNotification] = useState<Notification | null>(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    loadNotification();
  }, []);

  /** 
   * Handle displaying & auto-closing the popup message
  **/
  useEffect(() => {
    if (!isEmpty(notification)) {
      if (localStorage.getItem(`sms-gpt_message${notification.id}_dismissed`) == null) setVisible(true);
      const timeout = setTimeout(() => {
        setVisible(false);
        localStorage.setItem(`sms-gpt_message${notification.id}_dismissed`, '1');
      }, 120000);
      return () => clearTimeout(timeout);
    }
  }, [notification, 120000]);

  /** 
   * Handle 
  **/
  const loadNotification = async () => {
    const res = await getNotifications();
    const notification = await res?.json() as Notification[];
    setNotification(notification && notification.length > 0 ? notification[0] : null);
  };

  /** 
   * Handle closing the popup message
  **/
  const closeMessage = () => {
    setVisible(false);
    localStorage.setItem(`sms-gpt_message${notification?.id}_dismissed`, '1');
  };

  return (
    <>
      {!isEmpty(notification) &&
        <AnimatePresence>
          {visible && (
            <motion.div
              initial={{ y: -100, opacity: 0 }}
              animate={{ y: 0, opacity: 1 }}
              exit={{ y: -100, opacity: 0 }}
              transition={{ type: 'spring', damping: 20, stiffness: 200 }}
              className="fixed inset-x-0 top-4 z-50 flex justify-center pointer-events-none"
            >
              <div className={`max-w-lg w-full bg-${notification?.color} bg-opacity-15 backdrop-blur-md border border-${notification?.color} dark:text-white rounded-3xl shadow-lg px-6 py-4 flex items-center space-x-3 pointer-events-auto`}>
                {/* <div className="flex-shrink-0">
                  <div className="logo"></div>
                </div> */}
                <div className="flex-1">
                  <p className="text-lg font-bold mb-2">{notification?.title}</p>
                  <p className="text-sm font-semibold mb-2">{notification?.message}</p>
                  <p className="text-xs">{notification?.subMessage}</p>
                </div>
                <div className="flex-shrink-0"><button type="button" onClick={closeMessage}><X className="text-accent" /></button></div>
              </div>
            </motion.div>
          )}
        </AnimatePresence>
      }
    </>
  );
};

export default MessagePopup;
